import { faList, faSearch, faTh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { MdKeyboardArrowLeft, MdOutlineKeyboardArrowRight, MdFirstPage, MdLastPage  } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
import defaultImage from "../images/default.jpg";
import {
    EVENT_FORMAT_URL,
    EVENT_STATUS_URL,
    GET_MY_EVENTS
} from './ApiDetails.js';

function LeftContainer({ setFilteredEventDates }) {
    const [eventFormatFilters, setEventFormatFilters] = useState([]);
    const [selectedEventFormat, setSelectedEventFormat] = useState("");
    const [statuses, setStatuses] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [events, setEvents] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [sortBy, setSortBy] = useState("Newest");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6;
    const [viewMode, setViewMode] = useState("card");
    const [mltEventFilter, setMltEventFilter] = useState(false);
    const [filteredEvents, setFilteredEvents] = useState([]);

    const navigate = useNavigate();
    const storedRole = localStorage.getItem('role');

    const [isWide, setIsWide] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 1024px)");

        // Set initial value
        setIsWide(mediaQuery.matches);

        // Listener for changes
        const handler = (e) => {
            setIsWide(e.matches);
            if (!e.matches) setViewMode("card");
        };
        mediaQuery.addEventListener("change", handler);

        return () => mediaQuery.removeEventListener("change", handler);
    }, []);

    useEffect(() => {
        const fetchEventFormat = async () => {
            try {
                const eventFormatResponse = await axios.get(EVENT_FORMAT_URL);
                setEventFormatFilters(eventFormatResponse.data);
            } catch (error) {
                console.error("Error fetching eventFormat data:", error);
            }
        };

        fetchEventFormat();
    }, []);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await axios.get(GET_MY_EVENTS);
                setEvents([...response.data.map(event => {
                    if (event.siteCode==="OFF") event.onelinerAddress = event.eventAddress.replace("\r\n", " ").replace("\r", " ").replace("\n", " "); else {
                        if ((event.cityName!=="") && (event.cityName!=="null") && (event.cityName!==null)) event.onelinerAddress = event.cityName;
                        if ((event.stateName!=="") && (event.stateName!=="null") && (event.stateName!==null)) event.onelinerAddress += (event.onelinerAddress!=="" ? ", " : "") + event.stateName;
                        if ((event.countryName!=="") && (event.countryName!=="null") && (event.countryName!==null)) event.onelinerAddress += (event.onelinerAddress!=="" ? ", " : "") + event.countryName;
                    }
                    return event;
                })]);

                const uniqueStatuses = (await axios.get(EVENT_STATUS_URL)).data;
                setStatuses(uniqueStatuses);

                const openEventDates = response.data
                    .filter(event => event.eventStatus === "Open event")
                    .map(event => new Date(event.eventDate));

                // Initialize selectedStatuses with all available statuses
                setSelectedEventFormat("All");
                setSelectedStatuses(uniqueStatuses);
                setFilteredEventDates(openEventDates);
            } catch (error) {
                console.error("Error fetching event data:", error);
            }
        };

        fetchEvents();
    }, [setFilteredEventDates]);

    const handleStatusClick = (status) => {
        setSelectedStatuses(prevStatuses =>
            prevStatuses.includes(status)
                ? prevStatuses.filter(s => s !== status)
                : [...prevStatuses, status]
        );
    };

    const handleMLTEventToggle = () => {
        setMltEventFilter(prev => !prev); // Toggle the state
    };

    const isDateInRange = (eventDate, eventEndDate, selectedDate, selectedEndDate) => {
        const eventStart = new Date(eventDate);
        const eventEnd = new Date(eventEndDate || eventDate);

        const selectedStart = selectedDate ? new Date(selectedDate) : null;
        const selectedEnd = selectedEndDate ? new Date(selectedEndDate) : null;
        return (
            (!selectedStart || eventStart >= selectedStart) &&
            (!selectedEnd || eventEnd <= selectedEnd)
        );
    };

    const handleEventFormatChange = (e) => {
        setSelectedEventFormat(e.target.value);
    };

    useEffect(() => {
        if (events) {
            const filteredData = events.filter(event => {
                const isMltEvent = event.mltEvent === true; // Assuming each event has an `mltEvent` property
                return (
                    (selectedEventFormat === "All" || selectedEventFormat === event.eventFormat) &&
                    (mltEventFilter ? isMltEvent : !isMltEvent) && // Filter based on mltEvent state
                    (selectedStatuses.includes(event.eventStatus)) &&
                    (searchQuery === "" || searchQuery === undefined || event.eventTitle.toLowerCase().includes(searchQuery.trim().toLowerCase()) ||
                        event.siteCode.toLowerCase().includes(searchQuery.trim().toLowerCase()) ||
                        event.eventVenueName.toLowerCase().includes(searchQuery.trim().toLowerCase())) &&
                    (selectedDate === "" && selectedEndDate === "" ||
                        isDateInRange(event.eventDate, event.eventEndDate, selectedDate, selectedEndDate))
                );
            });

            const filteredDates = filteredData.map(event => ({
                eventDate: event.eventDate,
                eventEndDate: event.eventEndDate,
                createdDate: event.createdDate,
                eventStatus: event.eventStatus,
                eventTitle: event.eventTitle,
                cityName: event.cityName,         // Include city name
                stateName: event.stateName,       // Include state name
                region: event.region,             // Include region
                countryName: event.countryName,   // Include country namec
                requestedBy: event.requestedBy,   // Include who requested the event
                coverImage: event.coverImage      // Include event cover image if needed
            }));

            setFilteredEventDates(filteredDates);
            setFilteredEvents(filteredData);
        }
    }, [events, selectedStatuses, statuses, searchQuery, selectedEndDate, selectedDate, sortBy, currentPage, mltEventFilter, selectedEventFormat]);

    const sortedEvents = [...filteredEvents].sort((a, b) => {
        if (sortBy === "Newest") {
            return new Date(b.eventDate) - new Date(a.eventDate);
        } else if (sortBy === "Oldest") {
            return new Date(a.eventDate) - new Date(b.eventDate);
        } else if (sortBy === "A to Z") {
            return a.eventTitle.localeCompare(b.eventTitle);
        } else if (sortBy === "Z to A") {
            return b.eventTitle.localeCompare(a.eventTitle);
        }
        return 0;
    });

    const totalPages = Math.ceil(sortedEvents.length / itemsPerPage);
    const currentEvents = sortedEvents.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const isMobile = window.innerWidth <= 400;
        const maxPageNumbersToShow = isMobile ? 2 : 5;

        let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
        let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

        if (endPage - startPage + 1 < maxPageNumbersToShow) {
            startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return pageNumbers;
    };

    return (
        <div className="leftcontainer d-flex flex-column progress-bar bg-white rounded-end" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ minHeight: '500px' }}>
            <div className="leftsearchbox">
                <div className="container-fluid d-flex align-items-center">
                    <div className="status-buttons">
                    <h6 className="calendar-headerh6 mr-2">Status</h6>
                        {statuses.map(status => (
                            <>
                                <div key={status} className={`status-button ${selectedStatuses.includes(status) ? 'selected' : ''}`} onClick={() => handleStatusClick(status)}>
                                    <span>{status}</span>
                                </div>
                                {status == 'Pending documentation' ? <br /> : ""}
                            </>
                        ))}
                    </div>
                {isWide ? (
                    <div className="col-md-1">
                        <FontAwesomeIcon
                            icon={viewMode === "card" ? faList : faTh}
                            onClick={() => setViewMode(viewMode === "card" ? "list" : "card")}
                            style={{ cursor: 'pointer', fontSize: '20px', marginTop: '5px' }}
                        />
                    </div>
                ) : ("")}
                </div>
                <br/>
                <div className="container-fluid align-items-center">
                    <div className="row gapBetweenLabels">
                        {/* Search Input */}
                        <div className="col-md-4">
                            <div className="input-group mb-0">
                                <label htmlFor="searchInput" className="input-group-text input-group-text-custom">Search</label>
                                <div style={{ position: 'relative', width: '70%' }}>
                                    <input
                                        type="text"
                                        className="form-control-custom rounded form-control"
                                        id="searchInput"
                                        placeholder="Type a keyword"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{ paddingRight: '30px' }}
                                    />
                                    <FontAwesomeIcon
                                        icon={faSearch}
                                        className="search-icon-custom"
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            cursor: "pointer",
                                            transform: 'translateY(-50%)'
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* Date Interval */}
                        <div className="col-md-4 d-flex align-items-center">
                            <label
                                htmlFor="dateInput"
                                className="input-group-text input-group-text-custom"
                                style={{
                                    whiteSpace: 'nowrap',
                                    // marginLeft: '-105px'
                                }}
                            >
                                Date Interval
                            </label>
                            <div className="requestorMainPageDateInterval" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <input
                                    type="date"
                                    className="form-control-custom rounded form-control selectDateInput text-cursor"
                                    id="dateInput"
                                    value={selectedDate}
                                    onChange={(e) => {
                                        const newDate = e.target.value;
                                        setSelectedDate(newDate);
                                        setSelectedEndDate(newDate);
                                    }}

                                />
                                <span style={{ fontWeight: 'bold' }}>to</span>
                                <input
                                    type="date"
                                    className="form-control-custom rounded form-control selectDateInput text-cursor"
                                    id="dateInput1"
                                    value={selectedEndDate}
                                    onChange={(e) => setSelectedEndDate(e.target.value)}

                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3 align-items-center adminPageSearchDateSpacing">
                        <div className="col-md-4">
                            <div className="input-group mb-0">
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <label className="input-group-text input-group-text-custom" htmlFor="sortBy">Sort By</label>
                                    <select
                                        className="form-control-custom rounded form-select"
                                        style={{ width: "130px", }}
                                        aria-label="Sort By"
                                        id="sortBy"
                                        value={sortBy}
                                        onChange={(e) => setSortBy(e.target.value)}
                                    // style={{ marginLeft: '10px', width: '100%' }}
                                    >
                                        <option value="Newest">Newest</option>
                                        <option value="Oldest">Oldest</option>
                                        <option value="A to Z">A to Z</option>
                                        <option value="Z to A">Z to A</option>
                                    </select>
                        </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                            <div className="input-group mb-0">
                                    <label
                                        htmlFor="eventFormat"
                                        className="input-group-text input-group-text-custom"
                                        style={{
                                            whiteSpace: "nowrap",
                                            // marginLeft: '-105px'
                                        }}
                                    >
                                        EVENT FORMAT
                                    </label>
                                    <select
                                        className="form-control-custom rounded form-select"
                                        style={{ width: "130px", }}
                                        aria-label="Event Format"
                                        id="eventFormat"
                                        value={selectedEventFormat}
                                        onChange={handleEventFormatChange}
                                    >
                                        <option key={-1} value="All">All</option>
                                        {eventFormatFilters.length > 0 &&
                                            eventFormatFilters.map((formatName, index) => (
                                                <option key={index} value={formatName}>
                                                    {formatName}
                                                </option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                    {storedRole === 'Admin' && (
                        <div className="col-md-4">
                            <div className="input-group mb-0">
                            <div
                                className="form-check form-switch"
                                style={{ display: "flex", alignItems: "center" }}
                            ><label
                                    className="form-check-label"
                                    htmlFor="onlyNotTakenVisit"
                                    style={{
                                        marginRight: "28px",
                                        fontWeight: "bold",
                                        color: "darkblue",
                                        fontSize: "14px",
                                        whiteSpace: "nowrap",
                                    }}
                                >Family Members</label>
                                <input
                                    className="form-check-input1"
                                    type="checkbox"
                                    id="onlyNotTakenVisit"
                                    checked={mltEventFilter}
                                    // onChange={(e) => setMltEventFilter(e.target.checked)}
                                    onChange={handleMLTEventToggle}
                                    style={{
                                        marginLeft: "-20px",
                                        fontWeight: "bold",
                                        color: "blue",
                                        appearance: "none",
                                        width: "34px",
                                        height: "20px",
                                        //backgroundColor: 'white',
                                        borderRadius: "34px",
//                                        position: "relative",
                                        outline: "none",
                                        cursor: "pointer",
                                        border: "1px solid darkblue",
                                        boxShadow: "0 0 2px rgba(0, 0, 0, 0.2)",
                                        //transition: 'background-color 0.2s'
                                    }}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor="onlyNotTakenVisit"
                                    style={{
                                        marginLeft: "10px",
                                        fontWeight: "bold",
                                        color: "darkblue",
                                        fontSize: "14px",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    MLT
                                </label>
                            </div>
                        </div>
                        </div>
                    )}
                    </div>

                </div>
            </div>
            <div className="listitems">
                <div className="row card-group text-wrap text-start m-2 flex-wrap">
                    {currentEvents.map(event => (
                        <div key={event.id} className={viewMode === 'card' ? 'col-md-4 p-2' : 'list-group'}>
                            <div className="card-event" onClick={() => { const url = `/getDetail/${event.eventId}`; navigate(url); }} >
                                <div className={`card rounded ${viewMode === 'card' ? 'align-items-stretch' : 'list-group-item'} list-card`}>
                                    <div className={viewMode === 'card' ? "card-img-container" : "col-md-1 d-flex justify-content-between align-items-start d-none"}>
                                        {event.coverImage
                                            ? <img
                                                className={viewMode === 'card' ? "card-img-top-custom card-img-top rounded" : "d-flex justify-content-between align-items-start"}
                                                src={event.coverImage ?? defaultImage}
                                                alt={event.eventTitle} />
                                            : <div className='card-noimg-text'>
                                                <span className='line-clamp-3'>{event.eventTitle}</span>
                                            </div>}
                                    </div>
                                    <div className={`card-body-custom card-body ${viewMode === 'list' ? 'list-body col-md-9' : ''}`}>
                                        <h6 className={viewMode === 'list' ? 'list-header-custom line-clamp-2' : 'card-header-custom line-clamp-2'} title={event.eventTitle}>
                                            {event.eventTitle}
                                        </h6>
                                        <div className={viewMode === 'list' ? 'list-text-custom' : 'event-card-text-custom'}>
                                            {event.mltEvent
                                                ? event.mltGuests.filter(guest => guest.status === 'Confirmed').length > 0 && (
                                                    <>
                                                        with <b>{event.mltGuests.filter(guest => guest.status === 'Confirmed').map(guest => `${guest.user.firstName} ${guest.user.lastName}`).join(', ')}</b>
                                                    </>
                                                )
                                                : event.familyGuests.filter(guest => guest.status === 'Confirmed').length > 0 && (
                                                    <>
                                                        with <b>{event.familyGuests.filter(guest => guest.status === 'Confirmed').map(guest => `${guest.user.firstName} ${guest.user.lastName}`).join(', ')}</b>
                                                    </>
                                                )}


                                            {((event.eventStatus === "Open event") && (
                                               (!event.mltEvent && (event.familyGuests.filter(guest => guest.status === 'Confirmed').length < event.familyNum))
                                            || (event.mltEvent && (event.mltGuests.filter(guest => guest.status === 'Confirmed').length < event.mltNum))
                                            )) && (event.mltEvent 
                                                ? <>
                                                    <div>Still accepting MLT members <b>{event.mltGuests.filter(guest => guest.status === 'Confirmed').length} out of {event.mltNum}</b></div>
                                                </>
                                                : <>
                                                    <div>Still accepting Family members <b>{event.familyGuests.filter(guest => guest.status === 'Confirmed').length} out of {event.familyNum}</b></div>
                                                </>
                                            )}
                                            <div>
                                                <b>{new Date(event.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})} to {new Date(event.eventEndDate).toLocaleDateString('en-US', {timeZone: 'UTC'})} • {event.onelinerAddress}</b>
                                            </div><br />
                                            <span>Created by {event.requestedBy} on {new Date(event.createdDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}</span>
                                        </div>

                                    </div>

                                    <div>
                                        {viewMode === "card" ?
                                            <div className='card-footer card-footer-custom'>
                                                <Link to={`/getDetail/${event.eventId}`} className={`card-footer-button btn rounded-pill ${event.eventStatus}`}>{event.eventStatus.toUpperCase()}</Link>
                                            </div>
                                            :
                                            <div className='card-footer card-footer-custom event-btn col-md-2'>
                                                <Link to={`/getDetail/${event.eventId}`} className={`card-footer-button btn rounded-pill ${event.eventStatus}`}>{event.eventStatus.toUpperCase()}</Link>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="paging align-items-center" style={{userSelect: 'none'}}>
                <span className="centered-text">
                    {(totalPages>0) && (<>{(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, sortedEvents.length)} OF{" "}</>)}
                    {sortedEvents.length} ELEMENTS &nbsp;&nbsp;
                </span>
                <nav>
                    <ul className="pagination justify-content-end" style={{ marginBottom: "17px", cursor: "pointer" }}>
                        <li className={`page-item ${((totalPages===0) || currentPage === 1) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdFirstPage /></span>
                        </li>
                        <li className={`page-item ${((totalPages===0) || currentPage === 1) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(currentPage - 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdKeyboardArrowLeft /></span>
                        </li>
                        {getPageNumbers().map((number) => (
                            <li key={number} className={`page-item ${currentPage === number ? "active" : ""}`}>
                                <span className="page-link" onClick={() => handlePageClick(number)} style={{ fontSize: "12px", padding: "4px 8px" }}>{number}</span>
                            </li>
                        ))}
                        <li className={`page-item ${((totalPages===0) || currentPage === totalPages) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(currentPage + 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdOutlineKeyboardArrowRight /></span>
                        </li>
                        <li className={`page-item ${((totalPages===0) || currentPage === totalPages) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(totalPages)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdLastPage /></span>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}

export default LeftContainer;